import React from 'react';
import { Icon } from '../../../shared/utils/icons';

const EmptyState = ({ onClear }) => (
    <div className="empty-state">
        <div className="empty-icon">
            <Icon name="search" size={24} />
        </div>
        <h3>No events match these filters</h3>
        <p>Try clearing a filter or broadening your search to see more of the global program.</p>
        <button className="btn" onClick={onClear}>
            <Icon name="reset" size={13} strokeWidth={2} /> Clear all filters
        </button>
    </div>
);

export default EmptyState;
